import { type EventMap } from '@/posthog';
import { StateCreator, StoreApi } from 'zustand';

type PricingModalContext = {
  reportInfo: PricingModalReportInfo;
  cancel_url?: string;
  success_redirect?: string;
  topHeader?: React.ReactNode;
  initialProduct?: string;
  initialCredit?: string;
  action?: 'downloadHD' | 'operate';
};
const initialState = {
  isPricingModalOpen: false,
  pricingModalContext: {} as PricingModalContext,
};

type PricingModalState = typeof initialState;

export type PricingModalReportInfo = {
  open_way: EventMap['user_open_pricing_modal']['open_way']; // 打开方式
  user_id: string; // 用户id
  email: string; // 用户邮箱
  user_identity: number; // 用户身份
  moduleName: EventMap['price_success']['pay_from_module'];
};

type PricingModalAction = {
  setPricingModalOpen: (
    open: boolean,
    context: {
      reportInfo: PricingModalReportInfo;
      cancel_url?: string;
      success_redirect?: string;
      topHeader?: React.ReactNode;
      initialProduct?: string;
      initialCredit?: string;
      // 操作类型
      // downloadHD: 下载高清图片
      // operate: 操作
      action?: 'downloadHD' | 'operate';
    }
  ) => void;
};

export type PricingModalStore = PricingModalState & PricingModalAction;

const pricingModalActions = (
  set: StoreApi<PricingModalStore>['setState'],
  get: StoreApi<PricingModalStore>['getState'],
  api: StoreApi<PricingModalStore>
): PricingModalAction => ({
  setPricingModalOpen: (open: boolean, context) =>
    set({ isPricingModalOpen: open, pricingModalContext: context }),
});

export const usePricingModalStore: StateCreator<PricingModalStore> = (
  set,
  get,
  api
) => ({
  ...initialState,
  ...pricingModalActions(set, get, api),
});
